import React from "react";
import { array } from "prop-types";
import { connect } from "react-redux";
import get from "lodash/get";
import { Link } from "@quintype/components";
import MobilePlayStore from "../../molecules/mobilePlayStore";
import MobileLogo from "../../atoms/MobileLogo";
import UpArrow from "../../icons/up-arrow";
import { DefaultFooter } from "./DefaultFooter";
import FooterMenu from "../../molecules/footerMenu";

import "./styles.m.css";

const FooterBase = ({ operaminiMenuItems }) => {
  return (
    <React.Fragment>
      <FooterMenu menu={operaminiMenuItems} />
      <div styleName="logo-arrow-wrapper">
        <Link href="/">
          <MobileLogo />
        </Link>
        <a href="#top" styleName="up-arrow">
          <UpArrow />
        </a>
      </div>
      <MobilePlayStore />
      <div styleName="footer" id="defaultFooter">
        <DefaultFooter />
      </div>
    </React.Fragment>
  );
};

function mapStateToProps(state) {
  return {
    operaminiMenuItems: get(state, ["qt", "data", "navigationMenu", "operaminiMenuItems"], [])
  };
}

FooterBase.propTypes = {
  operaminiMenuItems: array
};

export const Footer = connect(mapStateToProps, null)(FooterBase);
